import React,{useEffect} from 'react'
import "./CheckoutProduct.css"
import { useStateValue } from './StateProvider'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { NumericFormat } from 'react-number-format';

function CheckoutProduct({id,title,price,image,rating,hideButton,count,stock}) {
    const [{basket},dispatch]=useStateValue();
    const path=useHistory()
    useEffect(()=>{
        const user=JSON.parse(localStorage.getItem("user"))
        localStorage.setItem(`cart.${user}`,JSON.stringify(basket))
    },[basket])
    const addOne=()=>{
        const findItem=basket.find(p=>p.id===id)
        findItem.count++
        dispatch({
            type:"UPDATE"
        })
    }
    const removeFromBasket=()=>{
        const findItem=basket.find(p=>p.id===id)
        if(findItem.count===1){
            dispatch({
                type:"REMOVE_FROM_BASKET",
                id:id,
            });
        }
        else{
            findItem.count--
            dispatch({
                type:"UPDATE"
            })
        }
    };
    return (
        
        <div className="checkoutProduct">
            <img className="checkoutProduct__image" src={image} alt=""/>
            <div className="checkoutProduct__info">
               <p className="checkoutProduct__title">{title}</p>
               <div className="checkoutProduct__price">
               <NumericFormat
                        renderText={(value) => (
                            <strong className='order__total'>{value}</strong>
                        )}
                        decimalScale={2}
                        value={price}
                        displayType={"text"}
                        thousandSeparator
                        prefix={"₹"}
                    />
                    <div>
                        <small className='badge badge-pill badge-success'>{stock <= 10 && stock > 0 && `Hurry up, only ${stock} left`}</small>
                        <small className='badge badge-pill badge-danger'>{stock === 0 || stock === null ? `Out of stock` : ''}</small>
                    </div>
               </div>
               {/* <div className="checkoutProduct__rating">
                   {Array(rating)
                     .fill()
                     .map((_,i)=>(
                         <p>⭐</p>
                     ))
                   }
               </div> */}
               {
                path.location.pathname==='/orders'?
                <>
                <p>Quantiy : {count}</p>
                <p>Total : ₹{price*count}</p>
                </>
                :
                        <>
                            {
                                path.location.pathname === '/checkout' &&
                                <><button onClick={removeFromBasket} disabled={count===0||stock===0} className='mr-1'>-</button>{count}
                                    <button className='ml-1' onClick={addOne} disabled={count === 10 || stock === count || stock === 0 || stock === null}>+</button>
                                </>
                            }
                            {
                                path.location.pathname === '/payment' &&
                                <span>Quantiy : {count}</span>
                            }
                            <NumericFormat
                                renderText={(value) => (
                                    <p className='mt-2'>Total : {value}</p>
                                )}
                                decimalScale={2}
                                value={price * count}
                                displayType={"text"}
                                thousandSeparator
                                prefix={"₹"}
                            />
                        </>
               }
               <hr></hr>
            </div>
            
        </div>
        

       
    )
}

export default CheckoutProduct